<ion-header class="absolute transparent">
  <app-header [middleIcon]="false" [hide930]="true" [backIcon]="isUserHighlighted" [menuIcon]="isUserHighlighted"></app-header>
</ion-header>
<ion-content class="theme-{{userService.theme}}">
  <div class="content">
    <div class="bg-header" [ngClass]="'bg-inner-'+userService.theme">
      <div class="wrap-logo">
        <img class="side-logo" [src]="userService.companyLogo">
        <div class="title">{{title}}</div>
      </div>
      <div class="table-header">
        <div class="elem">{{ "__LEADERBOARD_POSITION__" | translate }}</div>
        <div class="left elem">{{ "__LEADERBOARD_NAME__" | translate }}</div>
        <div class="elem">{{ "__LEADERBOARD_LOCATION__" | translate }}</div>
        <div class="bg-1 elem">{{ "__LEADERBOARD_PRE_WORK__" | translate }}</div>
        <div class="bg-2 elem"><div>{{ "__LEADERBOARD_ENABLEMENT_SESSIONS__" | translate }}</div></div>
        <div class="bg-3 elem"><div>{{ "__LEADERBOARD_FINAL_EXAM__" | translate }}</div></div>
        <div class="bg-4 elem">{{ "__LEADERBOARD_TOTAL__" | translate }}</div>
      </div>
    </div>
    <div class="shadow-container" *ngIf="!leaderboardData">
      <app-skeleton-leaderboard
        *ngFor="let el of ['50%','60%','40%','45%','50%','60%','40%','45%','50%','60%']; let i = index; let even = even"
        [ngClass]="{ even: even }" [even]="even" [width]="el"></app-skeleton-leaderboard>
    </div>
    <div class="shadow-container" *ngIf="!!leaderboardData">
      <div class="grid-line" *ngFor="let el of leaderboardData; let i = index; let even = even"
           [@enter]="{ value: '', params: { delay: i * 20 } }"
           [ngClass]="{ even: even }">
        <div class="index" [ngClass]="{ dark: even }">{{ i + 1 }}</div>
        <div class="left">{{ el.full_name }}</div>
        <div class="location">{{ el.location }}</div>
        <div class="no-border">{{ el.pre_event }}</div>
        <div class="blue no-border">{{ el.session1 }}</div>
        <div>{{ el.post_event }}</div>
        <div class="bold">{{ el.total }}</div>
      </div>
    </div>
  </div>

  <app-footer-logo [veeam]="true"></app-footer-logo>
</ion-content>
